import {
  FilterMode,
  AiSearchAutoEval_OrderBy,
  AiSearchAutoEval,
  SortOrder,
  AiSearchAutoEval_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const aiSearchAutoEvalService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.aiSearchAutoEvalOne({ id });
    return result.aiSearchAutoEvalOne as AiSearchAutoEval;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: AiSearchAutoEval_OrderBy[] | null = null,
    filter: AiSearchAutoEval_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: AiSearchAutoEval_Filter | undefined;
    if (searchValue !== "") {
      where = {
        runId: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.aiSearchAutoEvalListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ runId: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.aiSearchAutoEvalListWithOffset
    ) as AiSearchAutoEval[];
    return { list, orderBy };
  },
};
